import BotReportHeader from './BotReportHeader';
import withAuthorizer from 'components/ui/withAuthorizer';
import BotReportData from 'components/bots/reports/BotReportData';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

import { Resources } from 'helpers/ResourceHelper';

const BotReportPage = () => {
  const { reportId } = useParams();
  const [search, setSearch] = useState('');

  return (
    <>
      <BotReportHeader reportId={reportId} onSearch={setSearch} />
      <div className="container mt-4">
        <BotReportData reportId={reportId} search={search} />
      </div>
    </>
  );
};

export default withAuthorizer(BotReportPage, [Resources.BOT_MANAGER]);
